import { apiClient } from '@tsapiclient/zenauto.vehiclequotation.ts.client';
import {
  APIM_PUBLIC_SUBSCRIPTION_KEY,
  vehicleQuotationEndpoint,
} from './constants';
import { PricingType } from '../enums';
import { businessContractHire } from '../constants';

const subscriptionKey = APIM_PUBLIC_SUBSCRIPTION_KEY() as string;
const baseUrl = vehicleQuotationEndpoint as string;

const client = apiClient({
  subscriptionKey: subscriptionKey,
  baseUrl: baseUrl,
});

export const getOptionPrices = (
  id: number,
  duration: number,
  maintenance: boolean,
  payment: number,
  mileage: number,
  optionsSelected?: number[] | null,
  optionsAdded?: number | null,
  pricingType?: PricingType | null
) =>
  client.getOptionPrices(
    id,
    duration,
    maintenance,
    payment,
    mileage,
    optionsSelected,
    optionsAdded,
    pricingType === PricingType.Business ? businessContractHire : null
  );

export const getPricingOptions = () => client.getPricingOptions();

export const getVehicleDetails = (
  id: number,
  duration: number,
  maintenance: boolean,
  payment: number,
  mileage: number,
  optionsSelected?: Number[] | null,
  optionsAdded?: Number[] | null,
  pricingType?: PricingType | null
) =>
  client.getVehicleDetails(
    id,
    duration,
    maintenance,
    payment,
    mileage,
    optionsSelected,
    optionsAdded,
    pricingType === PricingType.Business ? businessContractHire : null
  );

export const getVehicleTechnical = (id: number) =>
  client.getVehicleTechnical(id);

export const getVehiclePricing = (
  id: number,
  duration: number,
  maintenance: boolean,
  payment: number,
  mileage: number,
  optionsSelected?: number[],
  optionsAdded?: number,
  pricingType?: PricingType | null
) =>
  client.getVehiclePricing(
    id,
    duration,
    maintenance,
    payment,
    mileage,
    optionsSelected,
    optionsAdded,
    pricingType === PricingType.Business ? businessContractHire : null
  );

export const getValidateOptions = (
  id: number,
  duration: number,
  maintenance: boolean,
  payment: number,
  mileage: number,
  addedOption: number,
  optionsSelected?: number[] | null
) =>
  client.getValidateOptions(
    id,
    duration,
    maintenance,
    payment,
    mileage,
    addedOption,
    optionsSelected
  );
